import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { authInterceptor } from './core/http/auth.interceptor';
import { routes } from './app.routing';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from './services/auth.service';
import { CookieService } from 'ngx-cookie-service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(withInterceptors([authInterceptor])),

        importProvidersFrom(
            ToastrModule.forRoot({
                timeOut: 5000,
                extendedTimeOut: 5000,
                positionClass: 'toast-top-right',
                preventDuplicates: true,
                enableHtml: true,
                progressBar: true,
                progressAnimation: 'increasing'
            })
        ),

        ConfirmationService,
        AuthService,
        CookieService
    ]
};
